import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import React from 'react';
import Typography from '@mui/material/Typography';

interface IconButtonWithConfirmationProps {
  children: any;
  selected?: boolean;
  size?: 'small' | 'medium';
  message?: string;
  disable?: boolean;
  onConfirm: () => void;
}

export function IconButtonWithConfirmation(
  props: IconButtonWithConfirmationProps
) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleOk = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    props.onConfirm();
    setAnchorEl(null);
  };
  const handleClose = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        component="span"
        color={props.selected ? 'primary' : 'default'}
        size={props.size}
        onClick={handleClick}
        disabled={props.disable ? props.disable : false}
      >
        {props.children}
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Typography sx={(theme) => ({ padding: theme.spacing(2) })}>
          <span
            dangerouslySetInnerHTML={{
              __html: props.message || 'Are you sure?'
            }}
          ></span>
        </Typography>
        <Grid container justifyContent="center">
          <Grid>
            <Button onClick={handleClose}>Cancel</Button>
          </Grid>
          <Grid>
            <Button onClick={handleOk}>OK</Button>
          </Grid>
        </Grid>
      </Popover>
    </>
  );
}
